const registry = new Map<string, any>();

export function registerAnalyticsView(key: string, value: any): void {
  registry.set(key, value);
}

export function getViewControl(viewType: string) {
  return registry.get(viewType)?.viewControl;
}

export function getViewBuckets(viewType: string) {
  if (viewType !== 'domestic') {
    if (viewType === 'ondemand') {
      return registry.get(viewType)?.getOnDemandBuckets();
    }
    return registry.get(viewType)?.buckets;
  }
}

export function getViewCharts(viewType: string) {
  if (viewType === 'ondemand') {
    return registry.get(viewType)?.getOnDemandCharts();
  }
  return registry.get(viewType)?.charts;
}
